export enum ListingPartPhase {
    LOADING = 'LOADING',
    HIDDEN = 'HIDDEN',
    UNAVAILABLE = 'UNAVAILABLE',
    DRAFT = 'DRAFT',
    PENDING = 'PENDING',
    LIVE = 'LIVE',
    LOCKED = 'LOCKED',
}

export interface PartStatusInfo {
    label: string;
    tone: 'live' | 'draft' | 'pending' | 'neutral';
}
